import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const paymentApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchPayment: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/search-payments?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['payments'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        deletePayments: build.mutation({
            query: (paymentIds) => {
                let list = {paymentIds: paymentIds};
                let paramData = serialize(list)
                return {
                    url: `/ajax/toggle/bulk/deleted/payment?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['payments'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportPaymentsData: build.query({
            query: (query) => {
                return {
                    url: `/export/payments`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("payments"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        uploadPaymentFile: build.mutation({
            query: (obj) => {
                const formData = new FormData();
                formData.append("file", obj.file);

                return {
                    url: `/ajax/uploadPayments/${obj.customerId}`,
                    method: 'POST',
                    body: formData,
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ["payments"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Uploaded", "Payments");
            },
        })
    }),
});

export const {
    useSearchPaymentQuery,
    useLazyExportPaymentsDataQuery,
    useUploadPaymentFileMutation,
    useDeletePaymentsMutation
} = paymentApi;